import { registerSW } from 'virtual:pwa-register';

// With registerType 'autoUpdate' the page reloads once a new worker activates.
registerSW({ immediate: true });
